import { render, staticRenderFns } from "./PaymentFarmsListComponent.vue?vue&type=template&id=55924b70"
import script from "./PaymentFarmsListComponent.vue?vue&type=script&lang=js"
export * from "./PaymentFarmsListComponent.vue?vue&type=script&lang=js"
import style0 from "./PaymentFarmsListComponent.vue?vue&type=style&index=0&id=55924b70&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55924b70')) {
      api.createRecord('55924b70', component.options)
    } else {
      api.reload('55924b70', component.options)
    }
    module.hot.accept("./PaymentFarmsListComponent.vue?vue&type=template&id=55924b70", function () {
      api.rerender('55924b70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/payment/components/PaymentFarmsListComponent.vue"
export default component.exports